module.exports = __webpack_public_path__ + "assets/img/1011587020650_.pic_hd.9af4cc61.jpg";